import React from "react";
import PropTypes from "prop-types";

const Button = ({
  children,
  variant = "primary", // Default value for variant
  onClick = null, // Default value for onClick
  className = "", // Default value for className
  ...props
}) => {
  return (
    <button
      className={`btn ${variant} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary", "outlined"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
